import fp from 'lodash/fp';
import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose, withProps } from 'recompose';
import { routes } from '../../../../constants';
import { Icon, SortableTable } from '../../../components';

const qualificationTypeColumns = [
  {
    name: 'name',
    display: () => 'Name',
    className: () => "name",
  },
  {
    name: 'edit',
    display: () => 'Edit',
    className: () => "edit",
  }
];

const AdminQualificationType = ({
  qualificationTypeRows
}) => (
    <div className='base-layout'>
      <section className='layout--header'>
        <Grid>
          <Row className='button-gutter'>
            <Col xs={12}>
              <h1>Qualification Type Admin</h1>
            </Col>
          </Row>
        </Grid>
      </section>
      <section id='section--admin-qualification-type' className='layout--section'>
        <Grid>
          <Row className='xs-gutter'>
            <Col xs={12} md={9}>
              <h2><Icon icon='caddie-links-large-alt' />Qualification Type</h2>
              <p>Add or manage Qualification Types.</p>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer to={routes.adminPortal.qualificationTypeAdd}>
                <Button className='large full'>
                  <Icon icon='add-large' /> Add Qualification Type
                </Button>
              </LinkContainer>
            </Col>
          </Row>
          <Row className='xs-gutter'>
            <SortableTable rows={qualificationTypeRows} columns={qualificationTypeColumns} className='table--admin-qualification-type' />
          </Row>
        </Grid>
      </section>
    </div >
  );

const mapStateToProps = (state) => ({
  qualificationTypes: fp.get('qualificationTypes')(state.user.profile)
})
const mapDispatchToProps = (dispatch) => ({
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(
    ({ qualificationTypes }) => ({
      qualificationTypeRows: fp.map(
        ({ id, name }) => ({
          id,
          name,
          edit: <div>
            <LinkContainer to={routes.adminPortal.qualificationTypeEdit(id)}>
              <Button bsStyle='plain'><Icon icon='edit-medium' />Edit</Button>
            </LinkContainer>
          </div>
        })
      )(qualificationTypes)
    })
  )
)(AdminQualificationType);


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/qualification-type-portal/qualification-type.js